// extracted by mini-css-extract-plugin
export var divider = "_g7-7";
export var itemsToggle = "_g7-8";
export var mergeModal = "_g7-1";
export var optionCard = "_g7-4";
export var radioGroup = "_g7-6";
export var radioOption = "_g7-0";
export var selected = "_g7-5";
export var shipmentOptions = "_g7-2";
export var tableOptions = "_g7-3";